/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Control_Track_Check_FailedInputs */



/**
* | output |
* | --- |
* | "The AD control track failed its self-check." |
*
* @param {Audio_Description_Export_Control_Track_Check_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_control_track_check_failed = /** @type {((inputs?: Audio_Description_Export_Control_Track_Check_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Control_Track_Check_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La piste de contrôle AD n'a pas réussi l'autovérification.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die AD-Steuerspur hat die Selbstprüfung nicht bestanden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La traccia di controllo AD non ha superato l'autoverifica.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управляющая дорожка АД не прошла самопроверку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La pista de control de AD no superó la autocomprobación.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AD 控制音轨未通过自检。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AD コントロールトラックがセルフチェックに失敗しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD कंट्रोल ट्रैक स्व-जाँच में विफल रहा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A faixa de controlo de AD falhou a autoverificação.")
	return /** @type {LocalizedString} */ ("The AD control track failed its self-check.")
});